module.exports = __webpack_public_path__ + "../resources/img/ic_plus_default.d9408964.svg";